module.exports = __webpack_public_path__ + "static/media/roomHistoryIcon.0ea77b54.svg";